import { render, staticRenderFns } from "./OneCheckBox.vue?vue&type=template&id=f61b96a4&"
import script from "./OneCheckBox.vue?vue&type=script&lang=js&"
export * from "./OneCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports